<template>
  <v-layout
    justify-center
    align-center
    column
    wrap
  >
    <v-flex>
      <v-btn
        v-for="link in links"
        :key="link.title"
        :href="link.link"
        color="white"
        flat
      >
        {{ link.title }}
      </v-btn>
    </v-flex>
    <v-flex
      primary
      text-xs-center
      white--text
      xs12
    >
      <v-btn
        v-for="social in socials"
        :key="social.title" 
        :href="social.link"
        fab 
        dark 
        small 
        flat      
      >
        <v-icon dark>{{ social.icon }}</v-icon>
      </v-btn>
    </v-flex>
     <v-flex white--text>
      Copyrigth © 2019 all Rights Reserved. Dashboard Ver. 1.0.0
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data () {
    return {
      links: [
        {
          title: 'Home',
          link: 'https://www.re121.com/'
        },
        {
          title: 'About Us',
          link: 'https://www.re121.com/how-to-invest-in-re121/'
        },
        {
          title: 'Team',
          link: ''
        },
        {
          title: 'Services',
          link: ''
        },
        {
          title: 'Blog',
          link: 'https://www.re121.com/blog/'
        },
        {
          title: 'Contact Us',
          link: ''
        },
      ],
      socials: [
        {
          title: 'Facebook',
          icon: 'fab fa-facebook-f',
          link: 'https://www.facebook.com/realestateonetwoone'
        },
        /*{
          title: 'Linkedin',
          icon: 'fab fa-linkedin',
          link: 'https://www.re121.com/'
        },*/
        {
          title: 'Twitter',
          icon: 'fab fa-twitter',
          link: 'https://twitter.com/re12114'
        },
        {
          title: 'Instagram',
          icon: 'fab fa-instagram',
          link: 'https://www.instagram.com/realestate.121'
        }
      ]
    }
  }
}
</script>